import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './uiSlice';
import sessionReducer from './sessionSlice';
import filtersReducer from './filtersSlice';
import { firestoreApi } from './firestoreApi';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    session: sessionReducer,
    filters: filtersReducer,
    [firestoreApi.reducerPath]: firestoreApi.reducer,
  },
  middleware: (gDM) =>
    gDM({ serializableCheck: false }).concat(firestoreApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
